export class Category {
  constructor(
    public readonly key: string,
    public readonly name: string,
    public readonly child_count: number,
    public readonly level: number,
    public readonly parent_id?: string,
  ) {}
}

export class CategoryTree {
  constructor(
    public readonly id: string,
    public readonly version: string,
    public readonly categories: Category[] = [],
  ) {}

  filterCategoriesByPaths(categoryPaths: string[]): Category[] {
    return this.categories.filter((c) => categoryPaths.includes(c.key));
  }

  filterCategoriesByLevel(level: number): Category[] {
    return this.categories.filter((c) => c.level === level);
  }
}

export class LandingPath {
  constructor(
    public readonly path: string,
    public readonly containedVersions: string[],
  ) {}

  get displayLabel(): string {
    return `${this.path} (${this.containedVersions.join(", ")})`;
  }
}
